const STORAGE_KEY = "stop:deploy-version";
const VERSION_QUERY = "_v";
const CHECK_INTERVAL_MS = 60 * 1000;

function publicPath() {
  const runtime = window.__STOP_CONFIG__ || {};
  let path = runtime?.URL?.PUBLIC_PATH || runtime?.URL?.STOP_APP_BASENAME || "/";
  if (!path.startsWith("/")) path = `/${path}`;
  if (!path.endsWith("/")) path += "/";
  return path;
}

function versionUrl() {
  return `${publicPath()}version.json`;
}

function readStoredTag() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function writeStoredTag(tag) {
  try {
    localStorage.setItem(STORAGE_KEY, tag);
  } catch {
    /* private mode / quota */
  }
}

/**
 * Si el tag cambió, navega con ?_v=<tag> para saltar HTML cacheado por
 * heurística (el primer deploy todavía no tiene no-store en todos los hops).
 * Si ya venimos con ese query, lo sacamos de la URL y no recargamos.
 */
export function applyDeployVersion(next) {
  const tag = String(next || "").trim();
  if (!tag || tag === "unknown") return false;

  const url = new URL(window.location.href);
  const busted = url.searchParams.get(VERSION_QUERY) === tag;

  if (busted) {
    writeStoredTag(tag);
    url.searchParams.delete(VERSION_QUERY);
    const clean = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState(null, "", clean);
    return false;
  }

  const prev = readStoredTag();
  if (!prev) {
    writeStoredTag(tag);
    return false;
  }
  if (prev === tag) return false;

  writeStoredTag(tag);
  url.searchParams.set(VERSION_QUERY, tag);
  window.location.replace(url.toString());
  return true;
}

export async function fetchFrontendVersion() {
  const response = await fetch(versionUrl(), {
    method: "GET",
    cache: "no-store",
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });
  if (!response.ok) return null;
  const payload = await response.json();
  const tag = payload?.tag || payload?.version?.tag || "";
  return String(tag).trim() || null;
}

export async function checkDeployVersionAndReload() {
  const next = await fetchFrontendVersion();
  return applyDeployVersion(next);
}

export function startDeployVersionWatcher() {
  const run = () => {
    checkDeployVersionAndReload().catch(() => {});
  };

  const onVisible = () => {
    if (document.visibilityState === "visible") run();
  };
  document.addEventListener("visibilitychange", onVisible);
  window.addEventListener("focus", run);
  const intervalId = window.setInterval(run, CHECK_INTERVAL_MS);

  return () => {
    document.removeEventListener("visibilitychange", onVisible);
    window.removeEventListener("focus", run);
    window.clearInterval(intervalId);
  };
}
